module.exports = __webpack_public_path__ + "static/media/money-packs-active-light-icon.1f9a0569.svg";